export default "__VITE_ASSET__BVe9LBCr__"